import tw from 'tailwind-styled-components'

export const LayoutCallLogButtonTimer = tw.div`fixed z-10 right-5 bottom-5`
